import { Component, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { PagoIngresoService } from '@app/core/service/pago-ingreso.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CreatePagopComponent } from './create-pagop/create-pagop.component';
import { Paginated } from '@app/core/model/paginated.model';
import { OrderService, ProductService, WarehouseService } from '@app/core';
import { ReporteService } from '@app/core/service/reporte.service';
import { ProveedorService } from '@app/core/service/proveedor.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-pago-proveedor',
  templateUrl: './pago-proveedor.component.html',
  styleUrls: ['./pago-proveedor.component.css']
})
export class PagoProveedorComponent implements OnInit {
  modalOptions: NgbModalOptions = {};
  pagos: any;
  private searchTermStream = new Subject<string>();
  currentSearchTerm: string = null;
  currentUserSubscription: Subscription;
  pago: any;
  products: any;
  proveedores: any[];
  paginanum=0;


  producto_id = new FormControl('', []);
  proveedor_id = new FormControl('', []);
  nro_comprobante: any = '';

  constructor(
    private pagoService: PagoIngresoService,
    private reporteService: ReporteService,
    private almacenService: WarehouseService,
    private modalService: NgbModal,
    private productoService: ProductService,
    private proveedorService: ProveedorService
  ) {}

  ngOnInit() {
    this.listProducts();
    this.listaProveedores();
    this.listarPagos('', '');

    this.producto_id.valueChanges.subscribe(data => {
      this.listarPagos(data, this.proveedor_id.value);
    });
    this.proveedor_id.valueChanges.subscribe(data => {
      this.listarPagos(this.producto_id.value, data);
    });
  }

  listaProveedores() {
    this.proveedorService.getProveedoresHabilitados().subscribe(data => {
      this.proveedores = data;
    });
  }

  listProducts() {
    this.productoService.getProductosAlmacen().subscribe(
      data => {
        this.products = data;
        console.log(data);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  updatepagos(ventas: Paginated) {
    const pedidosWithUpdatedNavs = this.updateNavUrls(
      this.currentSearchTerm,
      ventas
    );

    this.pagos = pedidosWithUpdatedNavs;

    console.log(this.pagos);
  }
  updateNavUrls(term: string, ventas: Paginated): Paginated {
    if (term) {
      if (ventas.prev_page_url) {
        ventas.prev_page_url += `&term=${term}`;
      }
      if (ventas.next_page_url) {
        ventas.next_page_url += `&term=${term}`;
      }
    }
    return ventas;
  }

  prevPage() {
    this.pagoService
      .getVentasAtUrl(this.pagos.prev_page_url)
      .then((pedidos: any) => {
        this.updatepagos(pedidos);
      });
  }

  nextPage() {
    this.pagoService
      .getVentasAtUrl(this.pagos.next_page_url)
      .then((ventas: any) => {
        this.updatepagos(ventas);
      });
  }

  listarPagos(producto_id: any, proveedor_id: any) {
    this.pagoService.listarPagos('', producto_id, proveedor_id).subscribe(a => {
      this.pagos = a;
      console.log(this.pagos);
    });
  }

  buscarPagos(nro_comprobante: any) {
    this.nro_comprobante = nro_comprobante;
    this.pagoService.listarPagos(nro_comprobante, '', '').subscribe(a => {
      this.pagos = a;
      console.log(this.pagos);
    });

    this.verificarTotal(nro_comprobante);
  }

  createPago(pago: any) {
    const modalRef = this.modalService.open(CreatePagopComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.title = 'PAGOS';
    modalRef.componentInstance.pago = pago;
    modalRef.result.then(result => {
      if (result) {
        this.listarPagos(this.producto_id.value, this.proveedor_id.value);
      }
    });
  }
  search(term: string) {
    this.searchTermStream.next(term);
  }

  verificarTotal(comprobante: any) {
    this.almacenService.buscarTotal(comprobante).subscribe((a: any) => {
      this.pago = a.total;
    });
  }

  crearPDF() {
    // console.log(this.Array);

    this.pagoService.pdfPogoIngreso(this.nro_comprobante).subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([x], { type: 'application/pdf' });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      const date = new Date();
      const link = document.createElement('a');
      link.href = data;
      link.download = 'pedido_' + date + '.pdf';
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
  }
}
